import { DimensionData } from '~/types/internal-api';
import { Dimension } from '~/app/shared/dimensions/types';
import { SelectedDimensionsProps } from './SelectedDimensions.types';

export default (data: DimensionData[] | (number | undefined)[], dimensions: Dimension[]): (number | undefined)[] => {
    if (isDimensionData(data)) {
        return fromDimensionData(data, dimensions);
    }

    return data;
};

function fromDimensionData(input: DimensionData[], dimensions: Dimension[]): (number | undefined)[] {
    return dimensions.map(dimension => {
        const dimensionData = input.find(line => line.dimensionId === dimension.id);
        return dimensionData ? dimensionData.dimensionKey : undefined;
    });
}

function isDimensionData(input: SelectedDimensionsProps['data']): input is DimensionData[] {
    return (
        Array.isArray(input) &&
        input.length > 0 &&
        typeof input[0] === 'object' &&
        Object.keys(input[0]).includes('dimensionId') &&
        Object.keys(input[0]).includes('dimensionKey')
    );
}

export const getListOfDimensionValuesNames = (ids: (number | undefined)[], allDimensions: Dimension[]) =>
    ids
        .map((id, index) => {
            if (typeof id === 'undefined') {
                return ' - ';
            }

            const dimension = allDimensions[index];
            const dimensionLine = dimension?.lines?.find(({ key }) => key === id);

            if (dimensionLine) {
                return dimensionLine.name;
            }

            return '?';
        })
        .join(', ');
